module.exports = __webpack_public_path__ + "static/image-bacterium-89e48aed96b12a9ec768f33439e29d62.webp";